import { Container, Grid, Typography, Box } from "@mui/material";
import SectionHeader from "../components/SectionHeader";

interface ServiceAreaProps {
  bgcolor?: string;
}

function ServiceArea({ bgcolor }: ServiceAreaProps) {
  return (
    <Box sx={{ width: "100%", bgcolor }}>
    <Container component="section" maxWidth="md" sx={{ py: 4, textAlign: "center" }}>
      <Grid container alignItems="center" spacing={4}>

        <Grid item xs={12} md={6}>
          <SectionHeader 
            title="Service Area"
            subtitle="We provide cleaning services within the Toronto city area. To help us serve you efficiently, please include your full address or postal code when submitting a request. This allows us to confirm availability and offer accurate pricing."
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              aspectRatio: "1 / 1",
              minHeight: "400px",
              backgroundImage: "url('https://djinni-assets.s3.us-east-1.amazonaws.com/main/area.jpg')",
              backgroundSize: "cover",         // Show the entire image
              backgroundPosition: "center",
              borderRadius: "8px", // Slightly rounded corners
            }}
          />
        </Grid>

      </Grid>

    </Container>
    </Box>
  );
}

export default ServiceArea;
